<template>
  <div id="app" :class="[{ mobOpen: $store.state.mobOpen, hideLogo: hideLogo }, $route.params.filter, subpage, $mq, 'page-' + page]">
    <div id="container" :class="{ open: $store.state.cardOpen, cardActive: $store.state.cardActive }">
      <div id="logo" ref="logo">
        <div id="logoInner" :style="{ transform: 'translate3d(0,0,0) rotate(' + mouse.z + 'deg)' }">
          <Logo />
        </div>
      </div>

      <transition name="fade" mode="out-in" @after-leave="changeView">
        <router-view :key="view" />
      </transition>
    </div>

    <Menu v-if="$route.name !== 'temporaire' && $route.name !== 'splash'" />
  </div>
</template>

<script>
import Menu from '@/components/Menu';
import Logo from '@/assets/images/Logo';
import JQuery from 'jquery';

export default {
  data() {
    return {
      showmenu: false,
      logo: null,
      page: null,
      hideLogo: false,
      allLinks: null,
      allLinks2: null,
      mouse: {
        x: 0,
        y: 0,
        z: 0,
      },
    };
  },

  components: {
    Menu,
    Logo,
  },

  methods: {
    mouseStuff() {
      let that = this;
      JQuery(document).ready(function () {
        JQuery(document).on('mouseover', 'a, .link', function () {
          that.hideLogo = true;
        });

        JQuery(document).on('mouseleave', 'a, .link', function () {
          that.hideLogo = false;
        });
      });

      window.addEventListener('mousemove', this.setMousePosition);
    },

    setMousePosition(e) {
      this.mouse.x = e.clientX;
      this.mouse.y = e.clientY;
    },

    loop() {
      this.logo.style.left = this.mouse.x + 'px';
      this.logo.style.top = this.mouse.y + 'px';
      this.mouse.z = this.mouse.z + 0.5 <= 360 ? this.mouse.z + 0.5 : 0;
      if (!this.overM) requestAnimationFrame(this.loop);
    },

    showL() {
      if (this.laureats) {
        setTimeout(() => (this.laureats = !this.laureats), 500);
      } else {
        this.laureats = !this.laureats;
      }
    },

    changeView() {
      let sub;
      if (this.$route.params.filter === 'annees' || this.$route.params.filter === 'domaine' || this.$route.params.filter === 'prix') sub = 'abLogo';
      this.page = this.$route.name + ' ' + sub;
    },
  },

  computed: {
    view() {
      let vw;
      if (this.$route.name === 'laureats') {
        vw = this.$route.params.filter;
      } else if (this.$route.name === 'laureats-laureat') {
        vw = this.$route.params.filter;
      } else if (this.$route.name === 'laureat') {
        vw = this.$route.params.slug;
      } else {
        vw = this.$route.name;
      }

      return vw;
    },

    subpage() {
      let vw;

      if (this.$route.name === 'laureats-laureat') {
        vw = 'archiveLaureat';
      } else {
        vw = false;
      }

      return vw;
    },

    splash() {
      return this.$store.getters.splash;
    },

    offline() {
      return this.$store.getters.offline;
    },
  },

  watch: {
    $route(to, from) {
      this.hideLogo = false;

      this.$nextTick(() => {
        this.hideLogo = false;
      });
    },

    offline(val) {
      this.showmenu = val === 0;
    },

    $mq() {
      if (this.$mq === 'lg') {
        this.mouseStuff();
      }
    },
  },

  mounted() {
    if (this.$mq === 'lg') {
      this.mouseStuff();
    }

    this.logo = this.$refs.logo;
    this.$store.dispatch('loadSplash');
    this.$store.dispatch('loadLaureats');
    this.$store.dispatch('loadAbout');
    this.$store.dispatch('loadCeremonies');

    this.$nextTick(() => {
      this.loop();
      this.changeView();
    });

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  },
};
</script>

<style lang="scss">
@import '@/assets/css/fonts.scss';
@import '../node_modules/normalize.css/normalize.css';
@import '@/assets/css/app.scss';
@import '@/assets/css/laureat.scss';
@import '@/assets/css/laureats.scss';

.block {
  padding: $block;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

#app {
  height: 100%;
  width: 100%;
  position: relative;
  cursor: none;
}

a,
.link {
  cursor: pointer;
}

#container {
  position: relative;
  height: 100%;
  width: 100%;
}

#app a {
  cursor: pointer;
}

.page-splash #logo {
  left: 50% !important;
  top: calc(#{$paddtop} + #{$logo} / 2) !important;
}

#logo {
  width: $logo;
  height: $logo;
  position: fixed;
  pointer-events: none;
  transform: translate3d(-50%, -50%, 0);
  z-index: 999;
  transition: opacity 0.2s;
}

#mobLogo {
  width: $logo;
  height: $logo;
  position: fixed;
  pointer-events: none;
  transform: translate3d(-50%, -50%, 0);
  z-index: 999;
}

.hideLogo #logo,
.mobOpen #logo {
  opacity: 0;
}

.hideLogo.page-splash #logo {
  opacity: 1;
}

.top {
  width: 100%;
  text-align: center;
  position: relative;
}

.upper {
  padding: 1.5rem 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: $line;
  z-index: 2;

  a:hover {
    font-style: normal;
  }

  div {
    margin-bottom: -1rem;
  }
}

.lower {
  padding: $block;
}

.aboutTitle {
  padding: 1.3rem 0;
  border-bottom: $line;
  text-align: center;
}

.subTitle {
  padding: 1.3rem 0;
  border-bottom: $line;
  text-align: center;
  text-transform: uppercase;
}

.title {
  flex: 1;
  text-align: center;
  margin-bottom: -1rem;
  padding: 0 1rem;
}

.close {
  cursor: pointer;
  position: absolute;
  font-size: 3.8rem;
  height: 100%;
  width: 4rem;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  top: 0;
  right: -4rem;
}

@media screen and (max-width: $breakPoint1) {
  #app {
    cursor: auto;
  }

  .hideLogo #logo {
    opacity: 1;
  }

  #logo {
    margin: 0 auto;
    box-sizing: content-box;
    padding: 2rem 0;
    width: $moblogo;
    height: $moblogo;
    position: relative;
    pointer-events: none;
    z-index: 2;
    transition: opacity 0.2s;
    display: block;
    top: auto !important;
    left: auto !important;
    transform: none;
  }

  #mobLogo {
    width: $moblogo;
    height: $moblogo;
    position: relative;
  }

  .page-splash,
  .abLogo {
    #logo {
      position: absolute;
      left: 50% !important;
      transform: translate(-50%, 0);
      top: 0 !important;
    }
  }

  .archiveLaureat #logo {
    z-index: 5;
  }

  .upper,
  .aboutTitle,
  .subTitle {
    border-bottom: $line2;
  }
}
</style>
